import { render } from "./ed-organism-login-block.vue?vue&type=template&id=505caf28"
import script from "./ed-organism-login-block.vue?vue&type=script&lang=js"
export * from "./ed-organism-login-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__